/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonConfigDto } from '../../models/person-config-dto';

export interface GetUserConfig$Params {
}

export function getUserConfig(http: HttpClient, rootUrl: string, params?: GetUserConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonConfigDto>> {
  const rb = new RequestBuilder(rootUrl, getUserConfig.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonConfigDto>;
    })
  );
}

getUserConfig.PATH = '/api/userprofile/config';
